import React, {useState} from "react";
import {useAtom, useSetAtom} from "jotai/index";
import {accountInfoAtom, nextStepAtom} from "./entity/entity";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {selValidUserId, signUp} from "../../services/platform/ManageUserAxios";
import {VerticalRule} from "../../components/common/Common";
import {
  ButtonGroup,
  Form, FormSection,
  FormSectionBody, FormSectionDescription, FormSectionHeader, FormSectionTitle,
  RequiredMark,
  SignUpVerify,
  ValidationScript
} from "./styles";
import {DefaultButton, RelativeDiv} from "../../assets/GlobalStyles";

export default function Basic(props) {
  const [showPassword, setShowPassword] = useState(false)
  const [accountInfo, setAccountInfo] = useAtom(accountInfoAtom);
  const setValidation = useSetAtom(nextStepAtom)
  const [isIdCheck, setIsIdCheck] = useState(false)
  const {register, handleSubmit, watch, formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: accountInfo
  })

  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  /**
   * 아이디 입력
   * @param event
   */
  const handleMemberId = (event) => {
    setIsIdCheck(false)
    setAccountInfo({
      ...accountInfo,
      username: event.target.value
    })
  }

  /**
   * 패스워드 입력
   * @param event
   */
  const handlePassword = (event) => {
    setAccountInfo({
      ...accountInfo,
      password: event.target.value
    })
  }

  /**
   * 패스원드 컨펌
   * @param event
   */
  const handleConfirmPassword = (event) => {
    setAccountInfo({
      ...accountInfo,
      confirmPassword: event.target.value
    })
  }

  /**
   * 매체명 입력
   * @param event
   */
  const handleMediaName = (event) => {
    setAccountInfo({
      ...accountInfo,
      siteName: event.target.value
    })
  }

  /**
   * 매체 사이트 URL 입력
   * @param event
   */
  const handleMediaSiteUrl = (event) => {
    setAccountInfo({
      ...accountInfo,
      siteUrl: event.target.value
    })
  }
  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setAccountInfo({
      ...accountInfo,
      managerName1: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    let num = event.target.value.replace(/[a-z]|[ㄱ-ㅎ]|[.-]/i, '')
    setAccountInfo({
      ...accountInfo,
      managerPhone1: num
    })
  }
  /**
   * 담당자 이메일 입력
   * @param event
   */
  const handleManagerEmail = (event) => {
    setAccountInfo({
      ...accountInfo,
      managerEmail1: event.target.value
    })
  }

  /**
   * 담당자 2 이름 입력
   * @param event
   */
  const handleSecondManagerName = (event) => {
    setAccountInfo({
      ...accountInfo,
      managerName2: event.target.value
    })
  }

  /**
   * 담당자 2 연락처 입력
   * @param event
   */
  const handleSecondManagerPhone = (event) => {
    let num = event.target.value.replace(/[a-z]|[ㄱ-ㅎ]|[.-]/i, '')
    setAccountInfo({
      ...accountInfo,
      managerPhone2: num
    })
  }

  /**
   * 담당자 2 이메일 입력
   * @param event
   */
  const handleSecondManagerEmail = (event) => {
    setAccountInfo({
      ...accountInfo,
      managerEmail2: event.target.value
    })
  }
  /**
   * 대행사 여부
   * @param mediaType
   */
  const handleChangeMediaType = (mediaType) => {
    setAccountInfo({
      ...accountInfo,
      mediaType: mediaType
    })
  }
  /**
   * 아이디 중복 체크
   */
  const checkUserId = () => {
    if (accountInfo.username === '') {
      toast.warning('아이디를 입력해주세요')
    } else {
      if ((/^[a-z]+[a-z0-9-_]{3,19}$/g).test(accountInfo.username)) {
        selValidUserId(accountInfo.username).then(response => {
          if (response.validUsername) {
            //사용가능한 아이디 입니다.
            toast.success('사용가능한 아이디입니다')
            setIsIdCheck(true)
          } else {
            toast.warning('중복된 아이디입니다')
            setIsIdCheck(false)
          }
        })
      } else {
        toast.warning('아이디를 확인해주세요')
      }
    }
  }
  /**
   * 회원가입
   */
  const onSubmit = () => {
    if (isIdCheck) {
      signUp(accountInfo).then(response => {
        if (response) {
          setValidation({
            terms: true,
            validation: true
          })
          props.nextStep();
        } else {
          setIsIdCheck(false);
          toast.warning('회원가입에 실패하였습니다. 관리자에게 문의하세요');
        }
      })
    } else {
      toast.warning('아이디 중복 검사를 해주세요');
    }
  }
  const onError = (error) => console.log(error)

  return (
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <article>
          <div><h2>기본 정보</h2></div>
          <VerticalRule/>
          <Form>
            <FormSection>
              <FormSectionHeader>
                <div>
                  <FormSectionTitle>기본 사용자 정보</FormSectionTitle>
                  <FormSectionDescription>로그인 및 담당자 정보를
                    입력해주세요.</FormSectionDescription>
                </div>
              </FormSectionHeader>
              <FormSectionBody>
                <div>
                  <div>대행사 구분</div>
                  <div>
                    <input type={'radio'}
                           id={'use'}
                           name={'direct'}
                           checked={accountInfo.mediaType === 'DIRECT'}
                           onChange={() => handleChangeMediaType('DIRECT')}/>
                    <label htmlFor={'use'}>매체사</label>
                    <input type={'radio'}
                           id={'unUse'}
                           name={'agency'}
                           checked={accountInfo.mediaType === 'AGENCY'}
                           onChange={() => handleChangeMediaType('AGENCY')}/>
                    <label htmlFor={'unUse'}>대행사</label>
                  </div>
                </div>
                <RelativeDiv>
                  <div>아이디<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        type={'text'}
                        autoComplete="off"
                        maxLength={20}
                        placeholder={'아이디를 입력해주세요'}
                        {...register("username", {
                          required: "아이디를 입력해주세요",
                          minLength: {
                            value: 4,
                            message: "4자~20자 사이 영문, 숫자, 일부 특수기호 (-,_)"
                          },
                          maxLength: {
                            value: 20,
                            message: "20자 내로 입력해주세요"
                          },
                          pattern: {
                            value: /^[a-z]+[a-z0-9-_]{3,19}$/g,
                            message: '아이디를 확인해주세요. (4~20자, 영문, 숫자, 일부 특수기호 -,_)'
                          },
                          onChange: (e) => handleMemberId(e)
                        })
                        }
                        value={accountInfo.username}
                    />
                    {errors.username &&
                        <ValidationScript>{errors.username?.message}</ValidationScript>}
                    <DefaultButton type='button' onClick={() => checkUserId()}
                                   style={isIdCheck ? {backgroundColor: '#ddd'}
                                       : null}>중복검사</DefaultButton>
                  </div>

                </RelativeDiv>
                <RelativeDiv>
                  <div>비밀번호<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        maxLength={16}
                        type={showPassword ? 'text' : 'password'}
                        placeholder={'대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)'}
                        {...register("password", {
                          required: "비밀번호를 입력해주세요",
                          pattern: {
                            value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/,
                            message: "비밀번호를 확인해주세요. 대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)"
                          },
                          onChange: (e) => handlePassword(e)
                        })}
                        value={accountInfo.password}

                    />
                    {errors.password &&
                        <ValidationScript>{errors.password?.message}</ValidationScript>}
                    <button className="password-toggle" type="button"
                            onClick={handleShowPassword}
                            aria-label={showPassword ? "비밀번호 숨기기" : "비밀번호 보기"}>
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path
                            d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"/>
                        <circle cx="12" cy="12" r="2.7"/>
                        {showPassword && <path d="m4 4 16 16"/>}</svg>
                    </button>
                  </div>
                </RelativeDiv>
                <RelativeDiv>
                  <div>비밀번호 확인<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        maxLength={16}
                        type={showPassword ? 'text' : 'password'}
                        placeholder={'대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)'}
                        {...register("confirmPassword", {
                          required: "비밀번호를 입력해주세요",
                          validate: (value) => {
                            if (watch('password') !== value) {
                              return "입력하신 비밀번호가 맞는지 확인부탁드립니다."
                            }
                          },
                          onChange: (e) => handleConfirmPassword(e)
                        })}
                        value={accountInfo.confirmPassword}
                    />
                    {errors.confirmPassword &&
                        <ValidationScript>{errors.confirmPassword?.message}</ValidationScript>}
                  </div>
                </RelativeDiv>
                <RelativeDiv>
                  <div>{accountInfo.mediaType === 'AGENCY' ? '대행사 명'
                      : '매체 명'}<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        type={'text'}
                        autoComplete="off"
                        placeholder={accountInfo.mediaType === 'AGENCY'
                            ? '대행사명을 입력해주세요. ex) ex)대행사명_년월일'
                            : '매체명을 입력해주세요. ex)매체명_년월일'}
                        {...register("siteName", {
                          required: "매체명을 입력해주세요",
                          onChange: (e) => handleMediaName(e)
                        })}
                        value={accountInfo.siteName}

                    />
                    {errors.siteName &&
                        <ValidationScript>{errors.siteName?.message}</ValidationScript>}
                  </div>
                </RelativeDiv>
                <RelativeDiv>
                  <div>매체 url<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        type={'text'}
                        autoComplete="off"
                        placeholder={'매체 사이트 정보를 입력해주세요'}
                        {...register("siteUrl", {
                          required: "매체 사이트 정보를 입력해주세요",
                          pattern: {
                            // eslint-disable-next-line
                            value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
                            message: '올바른 URL 주소를 입력해 주세요.'
                          },
                          onChange: (e) => handleMediaSiteUrl(e)
                        })}
                        value={accountInfo.siteUrl}
                    />
                    {errors.siteUrl &&
                        <ValidationScript>{errors.siteUrl?.message}</ValidationScript>}
                  </div>
                </RelativeDiv>
              </FormSectionBody>
            </FormSection>
            <div>
            <FormSection>
              <FormSectionHeader>
                <FormSectionTitle>담당자 정보(필수)</FormSectionTitle>
              </FormSectionHeader>
              <FormSectionBody>
                <RelativeDiv>
                  <div>담당자명<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        type={'text'}
                        placeholder={'담당자 명을 입력해주세요'}
                        {...register("managerName1", {
                          required: "담당자 명을 입력해주세요",
                          onChange: (e) => handleManagerName(e)
                        })}
                        value={accountInfo.managerName1}
                    />
                    {errors.managerName1 &&
                        <ValidationScript>{errors.managerName1?.message}</ValidationScript>}
                  </div>
                </RelativeDiv>
                <RelativeDiv>
                  <div>담당자 연락처<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        type={'text'}
                        placeholder={'연락처를 입력해주세요.'}
                        {...register("managerPhone1", {
                          required: "담당자 연락처를 입력해주세요.",
                          pattern: {
                            value: /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/,
                            message: "연락처 정보를 확인해주세요"
                          },
                          onChange: (e) => handleManagerPhone(e)
                        })}
                        value={accountInfo.managerPhone1}
                    />
                    {errors.managerPhone1 &&
                        <ValidationScript>{errors.managerPhone1?.message}</ValidationScript>}
                  </div>
                </RelativeDiv>
                <RelativeDiv>
                  <div>담당자 이메일<RequiredMark>*</RequiredMark></div>
                  <div>
                    <input
                        type={'text'}
                        placeholder={'이메일을 입력해주세요.'}
                        {...register("managerEmail1", {
                          required: "담당자 이메일을 입력해주세요.",
                          pattern: {
                            value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                            message: "이메일 형식을 확인해주세요"
                          },
                          onChange: (e) => handleManagerEmail(e)
                        })}
                        value={accountInfo.managerEmail1}
                    />
                    {errors.managerEmail1 &&
                        <ValidationScript>{errors.managerEmail1?.message}</ValidationScript>}
                  </div>
                </RelativeDiv>
              </FormSectionBody>
            </FormSection>
            <FormSection style={{marginTop: "15px"}}>
              <FormSectionHeader>
                <FormSectionTitle>담당자2 정보(선택)</FormSectionTitle>
              </FormSectionHeader>
              <FormSectionBody>
                <RelativeDiv>
                  <div>담당자명</div>
                  <div>
                    <input
                        type={'text'}
                        placeholder={'담당자 명을 입력해주세요'}
                        value={accountInfo.managerName2}
                        onChange={(e) => handleSecondManagerName(e)}
                    />
                  </div>
                </RelativeDiv>
                <>
                  <RelativeDiv>
                    <div>담당자 연락처</div>
                    <div>
                      <input
                          type={'text'}
                          placeholder={'연락처를 입력해주세요.'}
                          {...register("managerPhone2", {
                            validate: (value) => !value
                                || /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/.test(value)
                                || "연락처 정보를 확인해주세요",
                            onChange: (e) => handleSecondManagerPhone(e)
                          })}
                          value={accountInfo.managerPhone2}
                      />
                      {errors.managerPhone2 &&
                          <ValidationScript>{errors.managerPhone2?.message}</ValidationScript>}
                    </div>
                  </RelativeDiv>
                  <RelativeDiv>
                    <div>담당자 이메일</div>
                    <div>
                      <input
                          type={'text'}
                          placeholder={'이메일을 입력해주세요.'}
                          {...register("managerEmail2", {
                            validate: (value) => !value
                                || /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i.test(value)
                                || "이메일 형식을 확인해주세요",
                            onChange: (e) => handleSecondManagerEmail(e)
                          })}
                          value={accountInfo.managerEmail2}
                      />
                      {errors.managerEmail2 &&
                          <ValidationScript>{errors.managerEmail2?.message}</ValidationScript>}
                    </div>
                  </RelativeDiv>
                </>
              </FormSectionBody>
            </FormSection>
            </div>
          </Form>
        </article>
        <ButtonGroup $sticky>
          <button type="button" onClick={props.onCancel}>취소</button>
          <SignUpVerify type={"submit"}>회원가입</SignUpVerify>
        </ButtonGroup>
      </form>
  )
}